import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { DatePipe } from '@angular/common';
import { LanguageService } from 'src/app/services/language.service';
// import { PetDetail } from './../../interfaces/pet';
// import { PetDetailComponent } from 'src/app/dialogs/pet-detail/pet-detail.component';
// import { PetService } from 'src/app/services/pet.service';
// import { ModalService, modalopt } from '@coreui/angular'
import { Observable } from 'rxjs';

// import { OwnerDetailComponent } from 'src/app/dialogs/owner-detail/owner-detail.component';

// import { ModalService } from '@coreui/angular';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: 'language-dropdown.component.html',
  styleUrls: ['language-dropdown.component.scss']
})
export class LanguageDropdownComponent {
  supportedLanguages = ['en', 'fr', 'kh']; // Add your supported languages
  currentLanguage: string;

  constructor(private languageService: LanguageService) {
    this.currentLanguage = this.languageService.getSelectedLanguage();
  }

  changeLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
  }
}
